const sortLinks = function sortLinks(categoryLinks) {
  return categoryLinks.map(category => (
    {
      id: category.id,
      sort: category.sort,
      title: category.title,
      links: category.links.sort((linkA, linkB) => linkA.sort - linkB.sort),
    }
  )).sort((categoryA, categoryB) => categoryA.sort - categoryB.sort);
};

export default sortLinks;
